// @ts-nocheck
/* eslint-disable */
export const boldArrowCircleRightIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="#172E63" d="M8 1.333A6.67 6.67 0 0 0 1.334 8 6.67 6.67 0 0 0 8 14.667 6.67 6.67 0 0 0 14.667 8 6.67 6.67 0 0 0 8 1.333m2.687 7.02-2 2a.495.495 0 0 1-.707 0 .503.503 0 0 1 0-.706L9.127 8.5h-3.46a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5h3.46L7.98 6.353a.503.503 0 0 1 0-.706.503.503 0 0 1 .707 0l2 2a.503.503 0 0 1 0 .706"/></svg>`,
    name: 'bold-arrow-circle-right' as const
};